/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ContactInfoType {
    Unknown = 'Unknown',
    Email = 'Email',
    Phone = 'Phone',
    Fax = 'Fax'
}

export function ContactInfoTypeFromJSON(json: any): ContactInfoType {
    return ContactInfoTypeFromJSONTyped(json, false);
}

export function ContactInfoTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactInfoType {
    return json as ContactInfoType;
}

export function ContactInfoTypeToJSON(value?: ContactInfoType | null): any {
    return value as any;
}

